import { render } from "./SkinStoriesPaginated.vue?vue&type=template&id=02e0d699"
import script from "./SkinStoriesPaginated.vue?vue&type=script&lang=js"
export * from "./SkinStoriesPaginated.vue?vue&type=script&lang=js"

import "./SkinStoriesPaginated.vue?vue&type=style&index=0&id=02e0d699&lang=css"

import exportComponent from "/home/mihai/repos/skinscience/skinatlas/src/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__